var cache = {}

export default function(o, roll, done){

  var server = o.util.getUrl('frontend')

  if(cache[roll]){
    requestAnimationFrame(function(){
      done(cache[roll])
    })
  } else {
    $.ajax({
      url: `${server}?type=roll&roll=${roll}`,
      type: "GET",
    })
    .done(function(data, textStatus, jqXHR) {
      cache[roll] = data
      done(data)
    })
    .fail(function(jqXHR, textStatus, errorThrown) {
      console.error('error loading roll data')
      done()
    })
  }

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/data/roll/roll.js